<template>
  <v-autocomplete
    v-model="selectedColaboradores"
    :label="label"
    item-text="nome"
    item-value="colaboradores"
    :disabled="disabled"
    :items="arrayColaboradores"
    :dark="dark"
    :multiple="multiple"
    :rules="validate ? [rules.required] : ''"
    @change="onChanged()"
  >
    <template v-if="multiple" v-slot:prepend-item>
      <v-btn color="blue darken-2" text depressed @click="selectAll()">Marcar Todos</v-btn>&nbsp;
      <v-btn color="blue darken-2" text depressed @click="selectAll(false)">Desmarcar Todos</v-btn>

      <v-divider class="mt-2 mb-2"></v-divider>
    </template>

    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item }}</span>
      </v-chip>
      <span v-if="index === 1" class="red--text caption">(+{{ selectedColaboradores.length - 1 }})</span>
    </template>
  </v-autocomplete>
</template>

<script>
import rules from "@/utils/rules";

export default {
  name: "SelectColaboradoresByEquipe",

  props: {
    multiple: {
      type: Boolean,
      default: false
    },

    label: {
      type: String,
      default: "Colaboradores"
    },

    dark: {
      type: Boolean,
      default: false
    },

    validate: {
      type: Boolean,
      default: true
    },

    disabled: {
      type: Boolean,
      default: true
    },

    colaboradores: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      arrayColaboradores: [],
      selectedColaboradores: [],
      rules
    };
  },

  methods: {
    selectAll(all = true) {
      if (all) {
        this.selectedColaboradores = this.arrayColaboradores.map(
          colaborador => colaborador
        );
      } else {
        this.selectedColaboradores = [];
      }

      this.onChanged();
    },

    onChanged() {
      this.$emit("onChanged", this.selectedColaboradores);
    }
  },

  watch: {
    colaboradores(colaboradores) {
      this.arrayColaboradores = colaboradores
        .filter(
          colaborador =>
            (colaborador.id_funcao_nivel == 30 ||
              colaborador.id_funcao_nivel == 40) &&
            colaborador.ativo != null
        )
        .map(colaborador => colaborador.colaborador);
    }
  }
};
</script>
